import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=aedbae3e"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports